export enum SectionType {
    Section = 0,
    SubSection = 1,
    SubSubSection = 2,
    SubSubSubSection = 3,
}
